import { AppRoutes } from 'constants/routes';

const loaders = {
    main: () => import('web/pages/main/MainPage'),
    token: () => import('web/pages/token/TokenPage'),
    rewards: () => import('web/pages/rewards/Rewards'),
    vote: () => import('web/pages/vote/Vote'),
    swap: () => import('web/pages/swap/pages/SwapPage'),
    pools: () => import('pages/amm/pages/Analytics'),
    pool: () => import('pages/amm/pages/PoolPage'),
    createPool: () => import('pages/amm/pages/CreatePool'),
    delegate: () => import('pages/delegate/pages/DelegateMain'),
    becomeDelegate: () => import('pages/delegate/pages/BecomeDelegate'),
};
const pending = new Map<keyof typeof loaders, Promise<unknown>>();

export const prefetchRoute = (href: string) => {
    const connection = (
        navigator as Navigator & {
            connection?: { saveData?: boolean; effectiveType?: string };
        }
    ).connection;
    if (connection?.saveData || connection?.effectiveType?.includes('2g')) return;

    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname === window.location.pathname) return;
    const path = `${url.pathname.replace(/\/$/, '')}/`;
    let key: keyof typeof loaders;
    if (path === AppRoutes.page.main) key = 'main';
    else if (path === AppRoutes.page.token) key = 'token';
    else if (path === AppRoutes.page.rewards) key = 'rewards';
    else if (path === AppRoutes.page.vote) key = 'vote';
    else if (path.startsWith(AppRoutes.section.swap.base)) key = 'swap';
    else if (path === AppRoutes.section.amm.base) key = 'pools';
    else if (path.startsWith(AppRoutes.section.amm.link.create)) key = 'createPool';
    else if (path.startsWith(AppRoutes.section.amm.base)) key = 'pool';
    else if (path === AppRoutes.section.delegate.base) key = 'delegate';
    else if (path.startsWith(AppRoutes.section.delegate.link.become)) key = 'becomeDelegate';
    if (!key || pending.has(key)) return;
    pending.set(
        key,
        loaders[key]().catch(() => {
            pending.delete(key);
        }),
    );
};
